import React, { useMemo, useState } from 'react';
import {
	DocumentationFile,
	useDocumentationFilesQuery,
} from '../../../graphql/graphql';
import { useAppContext } from '../../../Services/AppContext';
import MediaViewer, { PreviewFile } from '../../Utils/MediaViewer/MediaViewer';
import Loading from '../../BaseModule/Components/Loading';
import { prepareDocumentationFileForMediaViewer } from '../../ECard/Services/eCardFile.service';
import MediaViewerModal from '../../Utils/MediaViewer/MediaViewerModal';
import netteApiClient from '../../../Services/NetteApiClient';

interface Props {
	documentationFileId: string;
	userId?: string;
}

const DocumentationFileView: React.FC<Props> = ({
	documentationFileId,
	userId,
}) => {
	const { data, isLoading } = useDocumentationFilesQuery({
		fileIds: [documentationFileId],
		userId: userId?.trim()?.length ? userId : undefined,
	});
	const [isOpen, setIsOpen] = useState(true);
	// @ts-ignore
	const { socketUrl, redirectToDashboard } = useAppContext();

	const handleClose = () => {
		netteApiClient.get(redirectToDashboard);
		setIsOpen(false);
	};

	const file: PreviewFile | undefined = useMemo(() => {
		const documentationFile = data?.documentationFiles
			?.data?.[0] as DocumentationFile;
		if (documentationFile) {
			return prepareDocumentationFileForMediaViewer(
				documentationFile,
				socketUrl,
			);
		}
	}, [data]);

	if (file && isOpen) {
		return <MediaViewerModal file={file} onClose={handleClose} opened />;
	}

	return <Loading />;
};

export default DocumentationFileView;
